/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Workout_PositionInputs */

const en_us2_workout_position = /** @type {(inputs: Workout_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current} of ${i?.total}`)
};

const pt_br2_workout_position = /** @type {(inputs: Workout_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current} de ${i?.total}`)
};

const es_419_workout_position = /** @type {(inputs: Workout_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current} de ${i?.total}`)
};

const pt_pt2_workout_position = /** @type {(inputs: Workout_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current} de ${i?.total}`)
};

const fr_fr2_workout_position = /** @type {(inputs: Workout_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current} sur ${i?.total}`)
};

const de_de2_workout_position = /** @type {(inputs: Workout_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current} von ${i?.total}`)
};

const it_it2_workout_position = /** @type {(inputs: Workout_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current} di ${i?.total}`)
};

/**
* | output |
* | --- |
* | "{current} of {total}" |
*
* @param {Workout_PositionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_position = /** @type {((inputs: Workout_PositionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_PositionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_position(inputs)
	if (locale === "es-419") return es_419_workout_position(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_position(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_position(inputs)
	if (locale === "de-DE") return de_de2_workout_position(inputs)
	if (locale === "it-IT") return it_it2_workout_position(inputs)
	return en_us2_workout_position(inputs)
});
export { workout_position as "workout.position" }